/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface DoublonsSearchDto
 */
export interface DoublonsSearchDto {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DoublonsSearchDto
     */
    nom1?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DoublonsSearchDto
     */
    nom2?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DoublonsSearchDto
     */
    prenom1?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DoublonsSearchDto
     */
    prenom2?: UnaccentTextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof DoublonsSearchDto
     */
    dateNaissance1?: DateSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof DoublonsSearchDto
     */
    dateNaissance2?: DateSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DoublonsSearchDto
     */
    registreNational1?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DoublonsSearchDto
     */
    registreNational2?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof DoublonsSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DoublonsSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DoublonsSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DoublonsSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DoublonsSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DoublonsSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DoublonsSearchDto interface.
 */
export function instanceOfDoublonsSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DoublonsSearchDtoFromJSON(json: any): DoublonsSearchDto {
    return DoublonsSearchDtoFromJSONTyped(json, false);
}

export function DoublonsSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoublonsSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom1': !exists(json, 'nom1') ? undefined : UnaccentTextSearchFromJSON(json['nom1']),
        'nom2': !exists(json, 'nom2') ? undefined : UnaccentTextSearchFromJSON(json['nom2']),
        'prenom1': !exists(json, 'prenom1') ? undefined : UnaccentTextSearchFromJSON(json['prenom1']),
        'prenom2': !exists(json, 'prenom2') ? undefined : UnaccentTextSearchFromJSON(json['prenom2']),
        'dateNaissance1': !exists(json, 'dateNaissance1') ? undefined : DateSearchFromJSON(json['dateNaissance1']),
        'dateNaissance2': !exists(json, 'dateNaissance2') ? undefined : DateSearchFromJSON(json['dateNaissance2']),
        'registreNational1': !exists(json, 'registreNational1') ? undefined : TextSearchFromJSON(json['registreNational1']),
        'registreNational2': !exists(json, 'registreNational2') ? undefined : TextSearchFromJSON(json['registreNational2']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DoublonsSearchDtoToJSON(value?: DoublonsSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom1': UnaccentTextSearchToJSON(value.nom1),
        'nom2': UnaccentTextSearchToJSON(value.nom2),
        'prenom1': UnaccentTextSearchToJSON(value.prenom1),
        'prenom2': UnaccentTextSearchToJSON(value.prenom2),
        'dateNaissance1': DateSearchToJSON(value.dateNaissance1),
        'dateNaissance2': DateSearchToJSON(value.dateNaissance2),
        'registreNational1': TextSearchToJSON(value.registreNational1),
        'registreNational2': TextSearchToJSON(value.registreNational2),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

